export function FormField({
  id,
  label,
  error,
  hint,
  required = false,
  children,
  className = ''
}) {
  const describedBy = [
    hint ? `${id}-hint` : null,
    error ? `${id}-error` : null
  ]
    .filter(Boolean)
    .join(' ') || undefined;

  return (
    <label className={`booking-field ${className}`.trim()} htmlFor={id}>
      <span className="booking-field__label">
        {label}
        {required ? <em aria-hidden="true"> *</em> : null}
      </span>
      {typeof children === 'function'
        ? children({ id, describedBy, invalid: Boolean(error) })
        : children}
      {hint ? (
        <small id={`${id}-hint`} className="booking-field__hint">
          {hint}
        </small>
      ) : null}
      {error ? (
        <small id={`${id}-error`} className="booking-field__error" role="alert">
          {error}
        </small>
      ) : null}
    </label>
  );
}
